import React from "react";
import { Box, Typography, TextField, Table, TableHead, TableRow, TableCell, TableBody, Paper, Button, Chip, IconButton } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Sidebar from "./Sidebar";
import { useNavigate } from "react-router-dom";
import numeroComprobante from "../api/numeroComprobante";
import { useEffect, useState } from "react"; // si no lo hiciste ya
import AirlineSeatReclineNormalOutlinedIcon from "@mui/icons-material/AirlineSeatReclineNormalOutlined";

const FacturacionMini = ({
  cliente,
  condicion,
  handleSuspenderCTACTE,
  handleSuspenderRemito,
  handleGoToSaldos,
  isSuspenderRemitoEnabled,
  puestoActual,
  theme,
  productos,
  handleDeleteRow,
  total,
  clientePercepciones,
  handleDeleteAll,
  updateProducto,
  estadoDespacho,
  handleFacturaElectronica,
  refreshNumero,
}) => {
  const [fechaHora, setFechaHora] = useState(new Date());
  const esDUO = JSON.parse(localStorage.getItem("esDUO")) || false;

  useEffect(() => {
    const interval = setInterval(() => {
      setFechaHora(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  const [numero, setNumero] = useState("Cargando...");
  const navigate = useNavigate();
  const smallFieldStyle = {
    "& .MuiInputLabel-root": {
      fontSize: window.innerWidth > 700 ? esDUO?"20px" :"16px" : "12px",
    },
    "& .MuiInputBase-input": {
      fontSize: window.innerWidth > 700 ? "16px" : "12px",
      marginRight: "9px",
    },
  };
  const solicitarAforadores = localStorage.getItem("solicitarAforadores");

  useEffect(() => {
    const fetchNumero = async () => {
      try {
        const puesto = JSON.parse(localStorage.getItem("puesto"));
        let idTalonarioFAA = null,
          idTalonarioFAB = null,
          idTalonarioREM = null;
        if (puesto?.talonarios) {
          puesto.talonarios.forEach(talonario => {
            talonario.talonarioDocumentos.forEach(doc => {
              switch (doc.idTipoMovimiento) {
                case "FAA":
                  idTalonarioFAA = talonario.idTalonario;
                  break;
                case "FAB":
                  idTalonarioFAB = talonario.idTalonario;
                  break;
                case "REM":
                  idTalonarioREM = talonario.idTalonario;
                  break;
              }
            });
          });
        }

        let idTalonarioAUsar = null;

        if (cliente) {
          const abreviaturaIVA = cliente?.categoriaIVA?.abreviaturaCategoriaIVA;
          const esContado = cliente?.condicionVenta?.condicionVentaContado;
          const emiteRemito = cliente?.emiteRemito;

          if (abreviaturaIVA === "RI" || abreviaturaIVA === "MO") {
            idTalonarioAUsar = !esContado && emiteRemito ? idTalonarioREM : idTalonarioFAA;
          }
        } else {
          // Sin cliente → factura tipo B
          idTalonarioAUsar = idTalonarioFAB;
        }

        if (!idTalonarioAUsar) {
          setNumero("No disponible");
          return;
        }

        const response = await numeroComprobante.getNumeroComprobante(idTalonarioAUsar);
        setNumero(response.data.nuevoNumeroComprobante);
      } catch (error) {
        console.error("Error obteniendo número de comprobante:", error);
        setNumero("No disponible");
      }
    };

    fetchNumero();
  }, [cliente, condicion, refreshNumero]); // 👈 ahora escucha refreshNumero

  return (
    <>
      <Sidebar handleFacturaElectronica={handleFacturaElectronica} handleDeleteAll={handleDeleteAll} clientePercepciones={clientePercepciones} />
      <Box
        sx={{
          marginTop: esDUO? "-2rem" : "-20px",
          width: "83%",
          backgroundColor: "white",
          boxSizing: "border-box",
          marginLeft: "5%",
        }}
      >
        {/* Número de Comprobante */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box
            sx={{
              minWidth: "120px",
              backgroundColor: theme.bandera.colorPrimario,
              color: "white",
              fontWeight: "bold",
              borderRadius: "4px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40px",
            }}
          >
            Número
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: 1,
              border: "1px solid #ccc",
              borderRadius: "4px",
              height: "40px",
              marginLeft: "15px",
              padding: "0 10px",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#555" }}>
              {numero}
            </Typography>
          </Box>
          <Box
            sx={{
              minWidth: "150px",
              height: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "0 10px",
              marginLeft: "15px",
            }}
          >
            <Typography variant="body1" sx={{ color: "#555" }}>
              <strong>Fecha y hora:</strong> {fechaHora.toLocaleDateString()} - {fechaHora.toLocaleTimeString()}
            </Typography>
          </Box>
        </Box>

        {/* Datos del Cliente */}
        <Box sx={{ display: "flex", mt: "5px", alignItems: "center" }}>
          <TextField disabled label="Cliente" value={cliente ? cliente.razonSocial : ""} fullWidth sx={{ ...smallFieldStyle, marginRight: "12px", mt: 2 }} />
          <TextField
            disabled
            label="DNI / CUIT / CUIL"
            value={cliente ? cliente.numeroDocumento : ""}
            sx={{ ...smallFieldStyle, mr: 0.5, width: "50%", mt: 2 }}
          />
          {solicitarAforadores == "true" && (
            <IconButton
              onClick={() => navigate("/datoschofer")}
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                color: "white",
                borderRadius: "5px",
                // minHeight: 50,
                // width: 40,
                ml: 1,
                mt: 1.5,
              }}
            >
              <AirlineSeatReclineNormalOutlinedIcon fontSize="medium" />
            </IconButton>
          )}

          {condicion !== "CONTADO" && (
            <Box sx={{ display: "flex", flexDirection: "column", ml: 1 }}>
              {/* Chip Emite Remito arriba */}
              {cliente && (cliente.emiteFacturayRemito || cliente.emiteRemito) && (
                <Chip
                  label="Emite Remito"
                  sx={{
                    backgroundColor: theme.palette.primary.gray,
                    color: theme.palette.primary.black,
                    fontSize: "12px",
                    height: "20px",
                    alignSelf: "flex-start",
                    mb: 0.2,
                  }}
                />
              )}

              {/* Fila horizontal de botones */}
              <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                {puestoActual?.verSaldoCliente && (
                  <Button
                    variant="contained"
                    onClick={handleGoToSaldos}
                    sx={{
                      backgroundColor: theme.bandera.colorSecundario,
                      color: "white",
                      fontWeight: "bold",
                      fontSize: 12,
                      textTransform: "none",
                      lineHeight: 1.2,
                      height: 45,
                      minWidth: 110,
                    }}
                  >
                    Ver
                    <br />
                    Saldo
                  </Button>
                )}

                <Button
                  variant="contained"
                  onClick={handleSuspenderRemito}
                  disabled={!isSuspenderRemitoEnabled}
                  sx={{
                    backgroundColor: theme.bandera.colorSecundario,
                    color: "white",
                    fontWeight: "bold",
                    fontSize: 12,
                    textTransform: "none",
                    lineHeight: 1.2,
                    height: 45,
                    minWidth: 110,
                    ml: 0.5,
                    mr: 0.5,
                  }}
                >
                  Suspender
                  <br />
                  Remito
                </Button>

                <Button
                  variant="contained"
                  onClick={handleSuspenderCTACTE}
                  sx={{
                    backgroundColor: theme.bandera.colorSecundario,
                    color: "white",
                    fontWeight: "bold",
                    fontSize: 12,
                    textTransform: "none",
                    lineHeight: 1.2,
                    height: 45,
                    minWidth: 110,
                  }}
                >
                  Suspender
                  <br />
                  CTA. CTE.
                </Button>
              </Box>
            </Box>
          )}
        </Box>

        {/* Ítems del comprobante */}
        <Typography sx={{ fontSize: "18px", fontWeight: "bold", mt: 1 }}>Ítems del comprobante</Typography>
        <Paper sx={{ width: "100%", minHeight: "180px", overflow: "hidden" }}>
          <Box sx={{ overflowY: "auto", height:  esDUO?"340px":"180px" }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Cantidad</TableCell>
                  <TableCell align="center">Descripción</TableCell>
                  <TableCell align="center">Precio</TableCell>
                  <TableCell align="center">Total</TableCell>
                  <TableCell align="center"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productos.map(producto => (
                  <TableRow key={producto.idProductoArray} sx={{ height: 40 }}>
                    <TableCell align="center" sx={{ py: 0.5 }}>
                      {producto.cantidadArticulo}
                    </TableCell>
                    <TableCell align="center" sx={{ py: 0.5 }}>
                      {producto.descripcionArticulo ? producto.descripcionArticulo : producto.descripcion}
                    </TableCell>
                    <TableCell align="center" sx={{ py: 0.5 }}>
                      {producto.precioPublico ? "$" + producto.precioPublico : ""}
                    </TableCell>
                    <TableCell align="center" sx={{ py: 0.5 }}>
                      {"$" + producto.importe}
                    </TableCell>
                    <TableCell align="center" sx={{ py: 0 }}>
                      <Button
                        onClick={() => handleDeleteRow(producto.idProductoArray, productos, updateProducto, estadoDespacho)}
                        sx={{ minWidth: "unset", p: "2px" }}
                      >
                        <HighlightOffIcon sx={{ color: "grey", fontSize: 35 }} />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Paper>

        {/* Totales */}
        <Typography sx={{ mt: 0.5, fontSize: "16px", fontWeight: "bold" }}>Totales</Typography>
        <Box sx={{ display: "flex", mt: "5px" }}>
          <TextField disabled label="Percepción IIBB" fullWidth value={clientePercepciones || "0"} sx={{ ...smallFieldStyle, marginRight: "10px" }} />
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "12px", marginBottom: "5px" }}>
              TOTAL
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: "bold", fontSize: "24px" }}>
              {total}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default FacturacionMini;
